import { cn } from "@aurem/ui";
import type { TranslationMatch } from "./parser";

type EditTranslationCaretProps = {
  match: TranslationMatch;
  isSelected: boolean;
  onSelect: (match: TranslationMatch | null) => void;
};

export const EditTranslationCaret = ({
  match,
  isSelected,
  onSelect,
}: EditTranslationCaretProps) => {
  const rect = match.element.getBoundingClientRect();

  if (rect.width === 0 || rect.height === 0) return null;

  return (
    <button
      type="button"
      className={cn(
        "pointer-events-auto fixed z-50 cursor-pointer rounded border border-dashed",
        isSelected
          ? "border-primary-500/80 bg-primary-500/5"
          : "border-primary-400/50 hover:border-primary-500/70 hover:bg-primary-500/5",
      )}
      style={{
        top: rect.top - 2,
        left: rect.left - 4,
        width: rect.width + 8,
        height: rect.height + 4,
      }}
      onClick={(e) => {
        e.stopPropagation();
        onSelect(isSelected ? null : match);
      }}
    />
  );
};
